import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import { tesaGrey1 } from "../../../styles/colors";

interface CardContentItemProps {
  text?: string;
  title?: string;
  header?: boolean;
  warning?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      fontFamily: "Proxima Nova Bold",
      fontSize: "1rem",
      lineHeight: "1.3125rem",
      marginTop: "0px",
      marginBottom: "8px",
    },
    key: {
      color: tesaGrey1,
      fontSize: "0.75rem",
      lineHeight: "0.9375rem",
      marginBottom: theme.spacing(1),
      marginTop: 0,
    },
    value: {
      fontWeight: 700,
    },
    warning: {
      color: theme.palette.error.main,
    },
  }),
);

const CardContentItem: React.FC<CardContentItemProps> = (props) => {
  const { children, header, title, text, warning } = props;
  const classes = useStyles();

  if (!text) {
    return children ? <div className={classes.key}>{children}</div> : null;
  }

  return (
    <p className={clsx({ [classes.key]: !header, [classes.header]: header })}>
      {title && `${title}: `}
      <span className={clsx(classes.value, { [classes.warning]: warning })}>{text}</span>
    </p>
  );
};

export default CardContentItem;
